export default "__VITE_ASSET__CAyclnY5__"